// extracted by mini-css-extract-plugin
module.exports = {"colorFgPrimary":"Toolbar_colorFgPrimary__N3tuJ"};